import { NederlandsAdres } from '@ha/domain';

export class AdresBuilder {
    private straat: string;
    private plaats: string;
    private huisnummer: number;
    private huisnummerToevoeging?: string;
    private postcode: string;

    withStraat(straat: string) {
        this.straat = straat;
        return this;
    }

    withPlaats(plaats: string) {
        this.plaats = plaats;
        return this;
    }

    withhuisnummer(huisnummer: number) {
        this.huisnummer = huisnummer;
        return this;
    }

    withHuisnummerToevoeging(huisnummerToevoeging: string) {
        this.huisnummerToevoeging = huisnummerToevoeging;
        return this;
    }

    withPostcode(postcode: string) {
        this.postcode = postcode;
        return this;
    }

    build(): NederlandsAdres {
        return {
            straat: this.straat,
            plaats: this.plaats,
            huisnummer: this.huisnummer,
            huisnummer_toevoeging: this.huisnummerToevoeging,
            postcode: this.postcode
        } as NederlandsAdres;
    }
}
